import { z } from "zod";
import { AddressKeySchemeSchema } from "@remi/enums/address-key-scheme";

import { GeoJSONPointSchema } from "./geojson";
import { State } from "./state";

export const PropertyAddressSchema = z.object({
  id: z.string().nullish(),
  addressStreet: z.string().min(1),
  city: z.string().min(1),
  countyCode: z.string().nullish(),
  zip: z.string().min(5),
  stateCode: z.enum(State),
  centerPointGeoJSON: GeoJSONPointSchema.nullish(),
  key: z.string().nullish(),
  keyScheme: AddressKeySchemeSchema.nullish(),
});

export type PropertyAddress = z.infer<typeof PropertyAddressSchema>;

export const UpdatePropertyAddressSchema = z.object({
  addressStreet: z.string().optional(),
  city: z.string().optional(),
  countyCode: z.string().optional(),
  zip: z.string().optional(),
  stateCode: z.enum(State).optional(),
  centerPointGeoJSON: GeoJSONPointSchema.optional(),
  key: z.string().nullish(),
  keyScheme: AddressKeySchemeSchema.nullish(),
});

export type UpdatePropertyAddress = z.infer<typeof UpdatePropertyAddressSchema>;

export const CreatePropertyAddressSchema = z.object({
  addressStreet: z.string(),
  city: z.string(),
  countyCode: z.string().nullish(),
  zip: z.string(),
  stateCode: z.enum(State),
  centerPointGeoJSON: GeoJSONPointSchema.optional(),
});

export type CreatePropertyAddress = z.infer<typeof CreatePropertyAddressSchema>;
